import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

export const MastercardFeaturesCard = () => {
    const { t } = useTranslation('processors')

    return (
        <Card className="mb-6">
            <CardHeader>
                <CardTitle>{t('mastercard.features.title')}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <h4 className="text-sm font-medium text-muted-foreground mb-3">{t('mastercard.features.paymentMethods')}</h4>
                        <div className="space-y-2">
                            <div className="flex items-center justify-between">
                                <span className="text-sm">Visa</span>
                                <Badge variant="default">{t('supported')}</Badge>
                            </div>
                            <div className="flex items-center justify-between">
                                <span className="text-sm">Mastercard</span>
                                <Badge variant="default">{t('supported')}</Badge>
                            </div>
                            <div className="flex items-center justify-between">
                                <span className="text-sm">American Express</span>
                                <Badge variant="default">{t('supported')}</Badge>
                            </div>
                            <div className="flex items-center justify-between">
                                <span className="text-sm">Discover</span>
                                <Badge variant="default">{t('supported')}</Badge>
                            </div>
                            <div className="flex items-center justify-between">
                                <span className="text-sm">JCB</span>
                                <Badge variant="default">{t('supported')}</Badge>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h4 className="text-sm font-medium text-muted-foreground mb-3">{t('features')}</h4>
                        <div className="space-y-2">
                            <div className="flex items-center justify-between">
                                <span className="text-sm">{t('threeDSecure')}</span>
                                <Badge variant="default">{t('available')}</Badge>
                            </div>
                            <div className="flex items-center justify-between">
                                <span className="text-sm">{t('recurringPayments')}</span>
                                <Badge variant="default">{t('available')}</Badge>
                            </div>
                            <div className="flex items-center justify-between">
                                <span className="text-sm">{t('storedCredentials')}</span>
                                <Badge variant="default">{t('available')}</Badge>
                            </div>
                            <div className="flex items-center justify-between">
                                <span className="text-sm">{t('authCapture')}</span>
                                <Badge variant="default">{t('available')}</Badge>
                            </div>
                            <div className="flex items-center justify-between">
                                <span className="text-sm">{t('refundsVoids')}</span>
                                <Badge variant="default">{t('available')}</Badge>
                            </div>
                            <div className="flex items-center justify-between">
                                <span className="text-sm">{t('multiCurrency')}</span>
                                <Badge variant="default">{t('available')}</Badge>
                            </div>
                            <div className="flex items-center justify-between">
                                <span className="text-sm">{t('fraudDetection')}</span>
                                <Badge variant="default">{t('available')}</Badge>
                            </div>
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

